import apiDefaults, { setAuthToken } from '@/api/defaultConfiguration';
import { tryParseInt } from '@/plugins/Utils';
import AuthRepository from '@/api/repositories/AuthRepository';

const authRepository = new AuthRepository();
let intervalId: NodeJS.Timeout | null = null;

function checkIsAuthorizationExpired(dispatch) {
	if (intervalId) {
		// @ts-ignore
		clearInterval(intervalId);
	}

	// @ts-ignore
	intervalId = setInterval(() => {
		const now = new Date().getTime() / 1000;
		const ttl = tryParseInt(localStorage.getItem('isAuthorizedTTL'));
		const expired = ttl === null || ttl < now;

		if (ttl && expired) {
			dispatch('logoutLocal');
			if (intervalId) {
				// @ts-ignore
				clearInterval(intervalId);
			}
		}
	}, 1500);
}

export default {
	state: {
		id: null,
		email: null,
		person: null,
		mail_signature: null,
		createdAt: null,
		usergroup: {
			level: null,
		},
		isAdAdmin: false,
		config: null,
		ttl: null,
		saveButtonState: null,
		CompanyRelationshipType: '',
		stripePaymentStored: false,
		onboarding: { completed: null, steps: {} },
	},
	getters: {
		getSaveButtonState(state) {
			return state.saveButtonState;
		},
		getUser(state) {
			return state;
		},
		getAuthenticatedUserGroupLevel(state) {
			return state.usergroup?.level?.toString();
		},
		isLocalAuthorized(state, getters) {
			const now = new Date().getTime() / 1000;
			const ttl = tryParseInt(localStorage.getItem('isAuthorizedTTL'));
			const isLocalAuthorizationExpired = ttl === null || ttl < now;
			const isAuthorized = localStorage.getItem('isAuthorized') === '1';

			return isAuthorized && !isLocalAuthorizationExpired;
		},
		isLocalAuthorizationExpired(state) {
			const now = new Date().getTime() / 1000;
			return state.ttl === null || state.ttl === undefined || state.ttl < now;
		},
		repairShopLabel(state) {
			if (state.usergroup?.level === 6) {
				return 'Reparaturbetrieb';
			} else if (state.usergroup?.level === 5) {
				return 'Autohaus';
			} else {
				return 'Autohaus / Reparaturbetrieb';
			}
		},
		isLevelAdmin(state) {
			return state.usergroup?.name === 'Administrator';
		},
	},
	mutations: {
		setSaveButtonState(state, payload) {
			state.saveButtonState = payload;
		},
		setAuthenticatedUser(state, payload) {
			state.id = payload.id;
			state.email = payload.email;
			state.person = payload.person;
			state.mail_signature = payload.mail_signature;
			state.createdAt = payload.createdAt;
			state.usergroup = payload.usergroup;
			state.config = payload.config;
			state.ttl = payload.ttl;
			state.isAdAdmin = payload.is_ad_admin;
			state.userSign = payload.userSign;
			state.CompanyRelationshipType = payload.company_relationship_type;
			state.stripePaymentStored = payload.stripe_payment_stored;
			state.onboarding = payload.onboarding;
		},
		setAuthenticatedUserLevel(state, payload) {
			state.usergroup.level = payload;
		},
	},
	actions: {
		async isAuthorized({ commit, dispatch, getters }) {
			const isAuthorized = localStorage.getItem('isAuthorized') === '1';

			if (isAuthorized && !getters.getUser.id) {
				await dispatch('updateAuthenticatedUser');
			}

			return isAuthorized;
		},
		updateAuthenticatedUser({ commit, dispatch }) {
			return authRepository
				.me()
				.then(response => {
					commit('setAuthenticatedUser', response.data);
					commit('setOnboardingData', response.data.onboarding);
					dispatch('loopUpdateNotifications');
					checkIsAuthorizationExpired(dispatch);
				})
				.catch(error => {
					dispatch('stopLoopUpdateNotifications');
					dispatch('logout');
				});
		},
		fetchMe({ commit, dispatch }) {
			return authRepository.me().then(response => {
				commit('setAuthenticatedUser', response.data);
				commit('setOnboardingData', response.data.onboarding);
			});
		},
		login({ commit, dispatch }, action) {
			return authRepository
				.login({
					email: action.email,
					password: action.password,
				})
				.then(response => {
					localStorage.setItem('isAuthorized', '1');
					localStorage.setItem('isAuthorizedTTL', response.data.ttl || '-1');
					localStorage.setItem('token', response.data.token || '');
					setAuthToken(response.data.token);
					checkIsAuthorizationExpired(dispatch);
					commit('setAuthenticatedUser', response.data);
					dispatch('loopUpdateNotifications');
				});
		},
		logoutLocal({ commit, dispatch }) {
			commit('setAuthenticatedUser', {});
			localStorage.removeItem('isAuthorized');
			localStorage.removeItem('isAuthorizedTTL');
			commit('clearDamageCase');
			commit('clearDamageCaseWorkingImages');
			commit('clearDamageCaseThumbnail');
			commit('clearNotifications');
			commit('clearDocuments');
			commit('clearRepairProof');
			dispatch('stopLoopUpdateNotifications');
			commit('clearAllUnfinishedMessages');
		},
		logout({ commit, dispatch }) {
			if (localStorage.getItem('isAuthorized') !== '1') {
				dispatch('logoutLocal');
				return;
			}

			return authRepository
				.logout()
				.then(response => {
					dispatch('logoutLocal');
				})
				.catch(error => {
					dispatch('logoutLocal');
				});
		},
	},
};
